<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Tax
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field name="name" label="Tax Name" type="text" v-model="queryParams.name"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="taxTypeList"
                label="Tax Type"
                v-model="queryParams.taxType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>

            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="taxList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.taxType }}</td>
                    <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date }}</td>
                    <td>{{ props.item.percentage }}</td>
                    <td>{{ props.item.updatedBy }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>
                      <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circles</v-icon>
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                    <td>
                      <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { taxService } from "../../services/tax-service";

export default {
  name: "TaxList",

  components: {},
  data: () => ({
    showListLoading: false,
    pageTitle: "Tax",
    breadcrumbs: [
      {
        text: "Tax Management",
        disabled: true
      },
      {
        text: "Taxs",
        disabled: true
      }
    ],
    headers: [
      { text: "Tax Name", align: "left", value: "name" },
      { text: "Tax Type", value: "taxType" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Tax Percentage", value: "percentage" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Description", value: "description" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0
    },
    taxList: [],
    totalRows: 0,
    statusList: [
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    taxTypeList: [
      { label: "Add On", value: "ADD_ON" },
      { label: "Inclusive", value: "INCLUSIVE" }
    ],
    queryParams: {
      name: "",
      status: "",
      taxType: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getTaxList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.taxType) {
      this.queryParams.taxType = this.$route.query.taxType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "taxs", query: this.queryParams });
      this.getTaxList();
    },
    getTaxList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      taxService
        .getTaxList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.taxList = res.data.taxList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/taxs/new");
    },
    onEdit(tax) {
      // go to details page
      this.$router.push("/taxs/" + tax.id);
    }
  }
};
</script>

<style scoped>
</style>

